<div class="header" *ngIf="type === 'page'">
	<div class="back-button" (click)="goBack()">
		<span class="freud-icon freud-icon-xs freud-icon-arrow-left"></span>
		{{ 'PROMPTUARY.GOBACK' | translate }}
	</div>

	<div class="headline">
		<div class="contact-name">{{ appointment?.userName }}</div>

		<div class="wrap-group">
			<div class="date">
				<span class="freud-icon freud-icon-sm freud-icon-calendar-event"></span>
				<div class="value">
					{{ appointment?.day | date: 'd MMM yy' }}
				</div>
			</div>

			<div class="hour">
				<span class="freud-icon freud-icon-sm freud-icon-clock"></span>
				<div class="value">{{ appointment?.day | date: "H'h'mm" }}</div>
			</div>
		</div>
	</div>
</div>

<div *ngIf="appointment && unifiedPromptuary.form">
	<div class="body" [ngClass]="{ 'body--sidebar': type === 'sidebar' }">
		<div class="title">
			{{ 'PROMPTUARY.ABOUT_SESSION' | translate }}
		</div>
		<promptuary-no-show
			[appointment]="appointment"
			(changeNoshow)="updateNoshow($event)"
			[type]="type"
		></promptuary-no-show>

		<div class="body-form" *ngIf="!appointment.noShow">
			<promptuary-reasons
				*ngIf="appointment"
				[appointmentId]="appointment.id"
				[initialValue]="appointment.contactReason"
				[formField]="unifiedPromptuary.form.get('reasons')"
				(onSaving)="unifiedPromptuary.setAutoSaveLoading('reasons')"
				(onSaved)="unifiedPromptuary.autosaveComplete('reasons')"
			></promptuary-reasons>

			<promptuary-cgi
				[type]="type"
				[clientId]="appointment?.profileId"
				[appointmentId]="appointmentId"
				[mainType]="mainType"
				[stepStart]="2"
				service="form"
				[formArray]="unifiedPromptuary.form.get('cgi')"
				(onSaving)="unifiedPromptuary.setAutoSaveLoading('cgi')"
				(onSaved)="unifiedPromptuary.autosaveComplete('cgi')"
				(onRequired)="unifiedPromptuary.cgiOnRequired($event)"
			></promptuary-cgi>

			<div *ngIf="isAssistanceJourney">
				<div class="field">
					<div class="info-row">
						<div class="wrap-group">
							<div class="info">
								{{ 'PROMPTUARY.ALARM_SIGNALS' | translate }}*
							</div>
							<div class="subinfo">
								{{ 'PROMPTUARY.ALARM_SIGNALS_H2' | translate }}
							</div>
						</div>
					</div>

					<div class="radio-group">
						<freud-radio-button
							[(ngModel)]="unifiedPromptuary.form.get('alarmSignals').value"
							[radioValue]="false"
							[bgColor]="false"
							[label]="'Não'"
							[name]="'alarmSignals'"
							(valueChange)="setAlarmsSignals(false)"
						>
						</freud-radio-button>

						<freud-radio-button
							[(ngModel)]="unifiedPromptuary.form.get('alarmSignals').value"
							[radioValue]="true"
							[bgColor]="false"
							[label]="'Sim'"
							[name]="'alarmSignals'"
							(valueChange)="setAlarmsSignals(true)"
						>
						</freud-radio-button>
					</div>

					<div
						*ngIf="
							appointment && unifiedPromptuary.form.get('alarmSignals')?.value
						"
						class="alarm-details"
					>
						<div class="info">
							{{ 'PROMPTUARY.ALARM_DESCRIPTION' | translate }}
						</div>
						<autosave-textarea
							[fetchInitialValue]="false"
							ngDefaultControl
							[formControl]="unifiedPromptuary.form.get('alarmSignalsReason')"
							[initialValue]="
								unifiedPromptuary.form.get('alarmSignalsReason')?.value
							"
							(valueSaving)="
								unifiedPromptuary.setAutoSaveLoading('alarmSignalsReason')
							"
							(valueSaved)="
								unifiedPromptuary.autosaveComplete('alarmSignalsReason')
							"
							[appointment]="autoSaveData"
							property="alarmSignalsReason"
							service="autoSaveField"
						></autosave-textarea>
					</div>
				</div>
			</div>

			<promptuary-outcome
				[formGroup]="unifiedPromptuary.form"
				[appointment]="appointment"
				[autoSaveData]="autoSaveData"
				[isAssistanceJourney]="isAssistanceJourney"
				(onChange)="setPromptuaryValue($event.field, $event.value)"
				(onSaving)="unifiedPromptuary.setAutoSaveLoading($event)"
				(onSaved)="unifiedPromptuary.autosaveComplete($event)"
			></promptuary-outcome>

			<promptuary-service-evolution
				[formGroup]="unifiedPromptuary.form"
				[autoSaveData]="autoSaveData"
				[appointment]="appointment"
				[showSpeechToText]="true"
				[showQuality]="true"
				[quality]="quality"
			></promptuary-service-evolution>

			<freud-button
				id="promptuary-form-page-button"
				*ngIf="type === 'page'"
				[disabled]="
					!stepsComplete || unifiedPromptuary.form.status === 'INVALID'
				"
				[loading]="unifiedPromptuary.autosaveLoading.length > 0"
				(click)="
					stepsComplete &&
						unifiedPromptuary.form.status === 'VALID' &&
						unifiedPromptuary.toggleRegisterModal(true)
				"
			>
				{{
					(unifiedPromptuary.autosaveLoading.length > 0
						? 'PROMPTUARY.SAVING_CHANGES'
						: 'PROMPTUARY.REGISTER'
					) | translate
				}}
			</freud-button>

			<div class="fixed-buttons" *ngIf="type === 'sidebar'">
				<promptuary-compliance-section
					type="default"
					[from]="from"
					[mainType]="mainType"
				></promptuary-compliance-section>
				<div class="zk-flex zk-gap-2">
					<freud-button
						color="secondary"
						[loading]="
							unifiedPromptuary.autosaveLoading.length > 0 ||
							unifiedPromptuary.isRegistering
						"
						(click)="cancel.emit()"
					>
						{{ 'PROMPTUARY.CANCEL' | translate }}
					</freud-button>
					<freud-button
						[disabled]="
							!stepsComplete || unifiedPromptuary.form.status === 'INVALID'
						"
						[loading]="
							unifiedPromptuary.autosaveLoading.length > 0 ||
							unifiedPromptuary.isRegistering
						"
						(click)="
							stepsComplete &&
								unifiedPromptuary.form.status === 'VALID' &&
								unifiedPromptuary.toggleRegisterModal(true)
						"
					>
						{{
							(unifiedPromptuary.autosaveLoading.length > 0
								? 'PROMPTUARY.SAVING_CHANGES'
								: 'PROMPTUARY.REGISTER'
							) | translate
						}}
					</freud-button>
				</div>
			</div>
		</div>
	</div>

	<div class="tabs">
		<tabs-row
			[selectedTabIndex]="tabIndex"
			[tabList]="tabList"
			(changeTab)="changeTab($event)"
		>
		</tabs-row>

		<div class="tabs__register" [ngClass]="{ 'zk-hidden': tabIndex !== 0 }">
			<div class="zk-flex zk-gap-2 zk-items-center zk-mb-3">
				<span class="freud-icon freud-icon-lock"></span>
				<div
					class="title"
					[innerHTML]="'PROMPTUARY.DOCUMENTARY_REGISTER_TITLE' | translate"
				></div>
			</div>
			<div
				class="subtitle"
				[innerHTML]="'PROMPTUARY.DOCUMENTARY_REGISTER_SUBTITLE' | translate"
			></div>
			<div
				class="text"
				[innerHTML]="'PROMPTUARY.DOCUMENTARY_REGISTER_TEXT' | translate"
			></div>
			<autosave-textarea
				*ngIf="appointment"
				placeholder="{{
					'PROMPTUARY.DOCUMENTARY_REGISTER_PLACEHOLDER' | translate
				}}"
				property="session-note"
				service="saveDocumentaryRecord"
				[appointment]="autoSaveData"
				(valueSaving)="unifiedPromptuary.setAutoSaveLoading('note')"
				(valueSaved)="unifiedPromptuary.autosaveComplete('note')"
			></autosave-textarea>
		</div>

		<div [ngClass]="{ 'zk-hidden': tabIndex !== 1 }">
			<promptuary-task
				[formGroup]="unifiedPromptuary.form"
				[appointmentId]="appointmentId"
				[contactId]="appointment?.profileId"
				[professionalId]="appointment?.professionalId"
				[name]="firstName"
			>
			</promptuary-task>
		</div>
	</div>
</div>

<promptuary-register-modal
	[showModal]="unifiedPromptuary.isRegisterModalOpen"
	[from]="from"
	[mainType]="mainType"
	[appointment]="appointment"
	[appointmentId]="appointmentId"
	[form]="unifiedPromptuary.form"
	promptuaryType="default"
	[promptuary]="unifiedPromptuary?.form?.value"
	[name]="firstName"
>
</promptuary-register-modal>

<promptuary-quality-modal
	[isVisible]="isQualityModalVisible"
></promptuary-quality-modal>
